import React from 'react';
import { Grid, TreeNavigation, ButtonBar, Button, XFilledIcon, SaveDiskIcon, ButtonSize, Alert, Loader } from 'react-unity';
import { OnPremAbstractPORForm, AbstractPORFormState, AbstractPORFormProps, IPORStateForm } from './OnPremAbstractPORForm';
import WorkflowDetailWrapper from '../common/wrappers/WorkflowDetailWrapper';
import PortOpeningRequestOnPrem from '../../models/entities/PortOpeningRequestOnPrem';
import { OnPremPORTypeInput } from './components/OnPremPORTypeInput';
import { OnPremRulesTable } from './components/OnPremRulesTable';
import TextInputField from '../../components/common/form-controls/TextInputField';
import { ApproverInput } from '../../components/PortOpeningRequests/components/ApproverInput'
import UserLookup from '../common/form-controls/UserLookup';
import TextAreaField from '../common/form-controls/TextareaField';
import AlertModal from '../common/modals/AlertModal';
import ConfirmModal from '../common/modals/ConfirmModal';
import { WorkflowState } from '../../models/enums/WorkflowState';
import PortOpeningRequestsCreate from './OnPremPortOpeningRequestsCreate';
import { PortOpeningRequestsDirection } from '../../models/enums/POR/PortOpeningRequestsDirection';
import './OnPremPortOpeningRequestsDetail.css';
import { useParams } from 'react-router-dom';
import ApprovePortOpeningRequestOnPrem from '../../models/viewModels/OnPremPortOpeningRequests/ApprovePortOpeningRequestOnPrem';
import CartaInput from '../common/form-controls/Lookups/CartaInput';


interface PortOpeningRequestsDetailWithParamsProps extends AbstractPORFormProps { }

interface StateForm extends IPORStateForm { }

interface PortOpeningRequestsDetailWithParamsState extends AbstractPORFormState<StateForm> {
	loading: boolean;
	portOpeningRequestOnPrem?: PortOpeningRequestOnPrem;
	editMode: boolean;
	matchPatch: string;

	decisionModalVisible: {
		approve?: boolean;
		reject?: boolean;
		review?: boolean;
		cancel?: boolean;
	},
	modalComment: string;
	selectedFromExisting: string[];
}

class PortOpeningRequestsDetailWithParams extends OnPremAbstractPORForm
	<PortOpeningRequestsDetailWithParamsProps, PortOpeningRequestsDetailWithParamsState> {

	constructor(props) {
		super(props);

		this.state = {
			loading: true,
			stateForm: {
				contact: null,
				connectionId: null,
				businessJustification: '',
				changeTicketId: null,
				cartaIds: [],
				ruleList: []
			},
			editMode: false,
			submissionWarned: false,
			operationInProgress: false,
			endModal: {
				visible: false,
			},
			submissionAlert: {
				visible: false,
			},

			decisionModalVisible: {},
			modalComment: '',
			selectedFromExisting: [],
			matchPatch: null,
		};

		this.initFormModel();
	}

	initFormModel() {
		super.initFormModel();
	}

	async componentWillMount() {
		const id = parseInt(this.props.params.porId);
		console.log(this.props.params.porId);
		await this.loadRequest(id);
	}

	loadRequest = async (id) => {
		this.setState(
			{
				loading: true
			},
			async () => {
				try {

					const request = await this.portOpeningRequestServiceOnPrem.getById(id);

					this.setState({
						portOpeningRequestOnPrem: new PortOpeningRequestOnPrem(request),
						loading: false,
					}, this.resetStateForm);

					this.setState({
						selectedFromExisting: this.state.stateForm.ruleList.map(rule => rule.name)
					});

				}
				catch (error) {
					const HTTP_FORBIDDEN_ERROR_CODE = 403;
					if (error.status === HTTP_FORBIDDEN_ERROR_CODE) {
						this.handleEndModal('You are not allowed to see this request.', 'error', 5000, '/onPremPortOpeningRequests');
					} else {
						this.handleEndModal('The request could not be retrieved.', 'error', 10000, '/onPremPortOpeningRequests');
					}
				}
			}
		);
	};

	resetStateForm = () => {
		this.setState((prevState) => (
			{
				stateForm: this.stateFormFromRequest(prevState.portOpeningRequestOnPrem),
			}
		));
	};

	stateFormFromRequest(
		por: PortOpeningRequestOnPrem
	): StateForm {
		const currentState =
			por.workflowInstance
				.currentWorkflowInstanceState
				.workflowState
				.value;

		const obj = super.stateFormFromRequest(por);

		const normalizedForm: StateForm = {
			...obj,
			changeTicketId: obj.changeTicketId ?? '',
			connectionId: obj.connectionId ?? 0,
			businessJustification:
				obj.businessJustification ?? '',
			cartaIds: (obj.cartaIds ?? []).map(carta => ({
				...carta,
				cartaAppId: carta.cartaAppId ?? '',
				cartaAppName: carta.cartaAppName ?? '',
				comment: carta.comment ?? '',
			})),
			ruleList: obj.ruleList ?? [],
		};

		if (
			currentState === WorkflowState.Review.value ||
			currentState === WorkflowState.Draft.value
		) {
			return {
				...normalizedForm,
				ruleList: normalizedForm.ruleList.map(rule => ({
					...rule,
					azureName: undefined,
				})),
			};
		}

		return normalizedForm;
	}

	setSelectedFromExisting = (rulesName: string[]) => {
		this.setState({
			selectedFromExisting: rulesName,
		})
	}

	actions = () => (
		!this.state.operationInProgress &&
		(
			<TreeNavigation className="em-u-clickable">
				{this.state.portOpeningRequestOnPrem?.isEditable() &&
					<>
						<TreeNavigation.Item
							label="Edit"
							className="em-c-btn em-c-btn--secondary em-c-btn--small"
							onClick={this.enableEdit}
						/>
						<br />
						<br />
					</>}
				{(this.state.portOpeningRequestOnPrem?.canHaveDOAGApproval() ||
					this.state.portOpeningRequestOnPrem?.canHaveReviewerApproval() || this.state.portOpeningRequestOnPrem?.canHaveImplementerApproval()) &&
					<>

						<TreeNavigation.Item
							label={this.state.portOpeningRequestOnPrem.workflowInstance.currentWorkflowInstanceState.workflowState.value == WorkflowState.AwaitingImplementation.value ?
								"Success" : "Approve"}
							className="em-c-btn em-c-btn--secondary em-c-btn--small"
							onClick={() => { this.openDecisionModal('approve'); }}
						/>
						<br />
						<br />
						<TreeNavigation.Item
							label={this.state.portOpeningRequestOnPrem.workflowInstance.currentWorkflowInstanceState.workflowState.value == WorkflowState.AwaitingImplementation.value ?
								"Failure" : "Reject"}
							className="em-c-btn em-c-btn--secondary em-c-btn--small"
							onClick={() => { this.openDecisionModal('reject'); }}
						/>
						<br />
						<br />
					</>}
				{/*this.state.portOpeningRequest?.isCancellable() &&
					<>
						<TreeNavigation.Item
							label="Cancel Request"
							className="em-c-btn em-c-btn--secondary em-c-btn--small"
							onClick={() => { this.openDecisionModal('cancel'); }}
						/>
						<br />
						<br />
				</>*/}
			</TreeNavigation>
		)
	);

	editActions = (size: ButtonSize) => (
		<ButtonBar className='edit-button-bar'>
			{!this.state.operationInProgress &&
				<>
					<ButtonBar.Item>
						<Button
							size={size}
							variant="secondary"
							onClick={this.cancelEdit}
						>
							<XFilledIcon
								size={size}
							/>
							<span>Cancel</span>
						</Button>
					</ButtonBar.Item>
					<ButtonBar.Item separator />
				</>}
			<ButtonBar.Item>
				<Button
					size={size}
					variant="primary"
					disabled={!this.formModel.isValid() || this.state.operationInProgress}
				>
					{(this.state.operationInProgress) ?
						<>
							<Loader className="icon-loader em-c-icon--small" />
							<span>Loading...</span>
						</>
						:
						<>
							<SaveDiskIcon
								className='em-c-save-icon'
								size={size}
							/>
							<span>Send to Review</span>
						</>
					}
				</Button>
			</ButtonBar.Item>
		</ButtonBar>
	);

	enableEdit = async () => {
		this.setState({
			editMode: true,
		});
	};

	cancelEdit = () => {
		this.setState({ editMode: false });
		this.resetStateForm();
	};

	openDecisionModal = (type: 'approve' | 'reject' | 'review' | 'cancel') => {
		this.setState({
			decisionModalVisible: {
				[type]: true
			}
		});
	};

	closeDecisionModal = () => {
		this.setState({
			decisionModalVisible: {},
			modalComment: '',
		});
	};

	setEmbedAlertSuccess = (message) => {
		this.setState({
			submissionAlert: {
				variant: 'success',
				text: message,
				visible: true,
			}
		}, () => {
			setTimeout(this.handleSubmissionAlertClose, 5000);
		});
	};

	rejectModalConfirmationField = () => ({
		label: 'Please, provide the reason.',
		value: this.state.modalComment,
		validation: {
			required: true,
		},
		onChange: (ev) => {
			this.setState({
				modalComment: ev.target.value,
			});
		},
	});

	approveModalConfirmationField = () => ({
		label: 'Approval Comment (Optional):',
		value: this.state.modalComment,
		validation: {
			required: false,
		},
		onChange: (ev) => {
			this.setState({
				modalComment: ev.target.value,
			});
		},
	});

	handleApprove = async () => {
		await this.handleOperationConfirmed({
			operation: async () => {
				let model: ApprovePortOpeningRequestOnPrem = { IsApproved: true, Reason: this.state.modalComment, ChangeTicketId: this.state.stateForm.changeTicketId };
				const currentState = this.state.portOpeningRequestOnPrem.workflowInstance.currentWorkflowInstanceState.workflowState.value;
				if (currentState === WorkflowState.PendingForDOAGApproval.value)
					await this.portOpeningRequestServiceOnPrem.doApproval(model, this.state.portOpeningRequestOnPrem?.id);
				else if (currentState === WorkflowState.Submitted.value)
					await this.portOpeningRequestServiceOnPrem.doReviewal(model, this.state.portOpeningRequestOnPrem?.id);
				else if (currentState === WorkflowState.AwaitingImplementation.value)
					await this.portOpeningRequestServiceOnPrem.doComplete(model, this.state.portOpeningRequestOnPrem?.id);
			},
			inProgressMessage: 'Approving...',
			successMessage: 'Request approved sucessfully.'
		});
	};

	handleReject = async () => {
		this.handleOperationConfirmed({
			operation: async () => {
				let model: ApprovePortOpeningRequestOnPrem = { IsApproved: false, Reason: this.state.modalComment, ChangeTicketId: this.state.stateForm.changeTicketId };
				const currentState = this.state.portOpeningRequestOnPrem.workflowInstance.currentWorkflowInstanceState.workflowState.value;
				if (currentState === WorkflowState.PendingForDOAGApproval.value)
					await this.portOpeningRequestServiceOnPrem.doApproval(model, this.state.portOpeningRequestOnPrem?.id);
				else if (currentState === WorkflowState.Submitted.value)
					await this.portOpeningRequestServiceOnPrem.doReviewal(model, this.state.portOpeningRequestOnPrem?.id);
				else if (currentState === WorkflowState.AwaitingImplementation.value)
					await this.portOpeningRequestServiceOnPrem.doComplete(model, this.state.portOpeningRequestOnPrem?.id);
			},
			inProgressMessage: 'Rejecting...',
			successMessage: 'Request rejected sucessfully.'
		});
	};

	handleCancellation = async () => {
	};

	handleOperationConfirmed = async ({
		operation,
		inProgressMessage,
		successMessage,
	}) => {
		this.setSubmissionAlertInProgress(inProgressMessage);
		this.closeDecisionModal();
		try {
			await operation();
			await this.loadRequest(this.state.portOpeningRequestOnPrem?.id);
			this.setEmbedAlertSuccess(successMessage);
		} catch (err) {
			const HTTP_INTERNAL_SERVER_ERROR_CODE = 500;
			if ((err.status === HTTP_INTERNAL_SERVER_ERROR_CODE) && err?.response?.data?.message) {
				await this.loadRequest(this.state.portOpeningRequestOnPrem?.id);
			}
			if (err?.status == 403 && (err?.response.headers.get("content-type") == "application/json" ? JSON.stringify(err?.response.data).includes("Application-Gateway") : err?.response?.data?.includes("Application-Gateway"))) {
				this.setSubmissionAlertError("The content you input contains some sensitive information.Please email to GSC-EMIT-ITOPS-HP-PLATFORMS-AZURE-CHINA.UG@exxonmobil.com and provide the UTC timestamp[" + new Date().toISOString() + "]. We will get back to you during our working hours (8:00 - 16:00 UTC + 8:00).");
			} else {
				this.setSubmissionAlertError(err?.response?.data?.message ?? 'An error occured when processing your request. Please, try again later.');
			}
		} finally {
			this.setState({
				operationInProgress: false,
				modalComment: '',
			});
		}
	};

	render() {
		//if (!this.state.loading) {
		//	debugger;

		//	const handlers = this.stateFormHandler();

		//	const debugValues = {
		//		contact: handlers.contact?.value,
		//		connectionId: handlers.connectionId?.value,
		//		businessJustification:
		//			handlers.businessJustification?.value,
		//		changeTicketId: handlers.changeTicketId?.value,
		//		cartaIds: handlers.cartaIds?.value,
		//		approver: handlers.approver?.value,
		//		ruleset: handlers.ruleset?.value,
		//		ruleList: this.state.stateForm?.ruleList,
		//	};

		//	console.error('POR values before rendering:', debugValues);
		//}
		return (
			((!this.state.loading &&
				this.state.portOpeningRequestOnPrem?.workflowInstance.currentWorkflowInstanceState.workflowState.value === WorkflowState.Draft.value
			)) ?
				<PortOpeningRequestsCreate 
					draftRequest={this.state.portOpeningRequestOnPrem}
				/>
				:
				<>
					<WorkflowDetailWrapper
						title={`Port Opening Request #${this.state.portOpeningRequestOnPrem?.id}`}
						workflowInstance={this.state.portOpeningRequestOnPrem?.workflowInstance}
						loading={this.state.loading}
						linkTree={this.getLinkTree()}
						actions={this.state.editMode ? this.editActions('small') : this.actions()}
						fromPOR
					>
						{this.state.submissionAlert.visible &&
							<Alert
								variant={this.state.submissionAlert.variant}
								onClose={this.handleSubmissionAlertClose}
							>
								{this.state.submissionAlert.text}
							</Alert>}
						<Grid variant="3-up">
							<Grid.Item>
								<OnPremPORTypeInput
									scope={{
										value: this.state.portOpeningRequestOnPrem?.direction.name,
										disabled: true
									}}
								/>
							</Grid.Item>

							<Grid.Item>
								<TextInputField
									label="Change Request Ticket"
									{...this.stateFormHandler().changeTicketId}
									disabled={this.state.operationInProgress || (!this.state.portOpeningRequestOnPrem?.canHaveImplementerApproval() && !this.state.editMode)}
									note={(this.state.portOpeningRequestOnPrem?.canHaveImplementerApproval()) ? "Please, add ServiceNow ticket" : ''}
								/>
							</Grid.Item>
						</Grid>
						<Grid variant="halves">
							<Grid.Item>
								<UserLookup
									label="Technical contact"
									{...this.stateFormHandler().contact}
									disabled={this.state.operationInProgress || !this.state.editMode}
								/>
							</Grid.Item>
							{this.requiresApproverVerification(this.state.portOpeningRequestOnPrem?.direction.name)
								?
								<Grid.Item>
									<ApproverInput
										{...this.stateFormHandler().approver}
										disabled={this.state.operationInProgress || !this.state.editMode}
									/>
								</Grid.Item>
								:
								<Grid.Item>
									<UserLookup
										label={'Approver (Delegate Owner)'}
										{...this.stateFormHandler().approver}
										disabled={this.state.operationInProgress || !this.state.editMode}
									/>
								</Grid.Item>
							}
						</Grid>
						
						<Grid variant="2-up">
							{this.requiresApproverVerification(this.state.portOpeningRequestOnPrem?.direction.name) ? (
										<Grid.Item>
											<CartaInput
												{...this.stateFormHandler().cartaIds}
												disabled={this.state.operationInProgress || !this.state.editMode}
												hideNotes={this.state.operationInProgress || !this.state.editMode}
											/>
										</Grid.Item>								
							) : (
								<Grid.Item>
									{/* <TextInputField
										type="number"
										label="Tracker Id"
										{...this.stateFormHandler().connectionId}
										disabled={this.state.operationInProgress || !this.state.editMode}
									/> */}
									<TextInputField
										label="Tracker Id"
										{...this.stateFormHandler().connectionId}
										disabled={this.state.operationInProgress || !this.state.editMode}
										//scope={this.state.stateForm?.selectedType}
										readOnly={this.state.loadingTracker}
										note={
											this.state.loadingTracker
												? "Validating..."
												: this.state.failedTracker
												? this.state.errorTracker
												: ""
										}
									/>
								</Grid.Item>
							)}
						</Grid>
						<TextAreaField
							label="Business Justification"
							{...this.stateFormHandler().businessJustification}
							disabled={this.state.operationInProgress || !this.state.editMode}
						/>
						<OnPremRulesTable
							{...this.stateFormHandler().ruleset}
							porDirection={this.state.portOpeningRequestOnPrem?.direction}
							readonly={this.state.operationInProgress || !this.state.editMode}
							currentWorkflowState={this.state.portOpeningRequestOnPrem?.workflowInstance.currentWorkflowInstanceState.workflowState.value}
							fromDetails
							selectedFromExisting={this.state.selectedFromExisting}
							setSelectedFromExisting={this.setSelectedFromExisting}
						/>

						{this.state.editMode && this.editActions('medium')}
					</WorkflowDetailWrapper>
					<AlertModal
						{...this.state.endModal}
						willTimeout={false}
						onClose={this.endAndRedirect}
					/>
					<ConfirmModal
						visible={this.state.decisionModalVisible.approve}
						title={`Approve POR #${this.state.portOpeningRequestOnPrem?.id}`}
						question="Are you sure you want to approve this request?"
						confirmationField={this.approveModalConfirmationField()}
						onConfirm={() => this.handleApprove()}
						onCancel={this.closeDecisionModal}
					/>
					<ConfirmModal
						visible={this.state.decisionModalVisible.cancel}
						title={`Cancel POR #${this.state.portOpeningRequestOnPrem?.id}`}
						question="Are you sure you want to cancel this request? This action cannot be undone."
						confirmationField={this.rejectModalConfirmationField()}
						confirmButton={{
							label: 'Cancel Request',
							props: {
								variant: 'primary',
								color: 'negative'
							}
						}}
						onConfirm={() => this.handleCancellation()}
						onCancel={this.closeDecisionModal}
					/>
					<ConfirmModal
						visible={this.state.decisionModalVisible.reject}
						title={`Reject POR #${this.state.portOpeningRequestOnPrem?.id}`}
						question="Are you sure you want to reject this request?"
						confirmationField={this.rejectModalConfirmationField()}
						onConfirm={() => this.handleReject()}
						onCancel={this.closeDecisionModal}
					/>
				</>
		);
	}
}

const PortOpeningRequestsDetail = () => {

	return <PortOpeningRequestsDetailWithParams params={useParams()} />;
}

export default PortOpeningRequestsDetail